import React, { Component } from 'react';

class CheckboxInput extends Component {

	onChange = (e) => {
		this.props.input.onChange(e.target.checked);
	};

	render() {
		const { meta: { error } } = this.props;

		const attributes = {
			id: this.props.id,
			type: 'checkbox',
			value: this.props.input.value,
			onChange: this.onChange,
			checked: this.props.input.value,
		};

		return (
			<div className="large-input-container">
				<div>
					<input {...attributes} />
					<label htmlFor={attributes.id}>{this.props.label}</label>
				</div>
				{error && <div className="large-input-container__error large-input-container__error--checkbox">{error}</div>}
			</div>
		);
	}
}

export default CheckboxInput;



// WEBPACK FOOTER //
// ./src/components/CheckboxInput.jsx